module.exports = __webpack_public_path__ + "static/media/banner-hcp.1af45f0b.jpg";